import { Drawer } from 'shared/components/Drawer/Drawer'
import { bgGray, lightGray1, royalBlue, white } from 'shared/theme/colors'
import { scrollbarHidden } from 'shared/theme/mixins'
import { styled } from 'styled-components'

import { NoteWrapDivider } from '../Notes/NoteItem'
import { NOTES_GAP } from '../Notes/Notes.constants'

export const StyledDrawer = styled(Drawer)<{ bgColor?: string }>`
  ${scrollbarHidden};

  padding: 0;
  background: ${({ bgColor }) => bgColor ?? bgGray};

  & .slim-notes-card {
    background-color: ${white};
  }

  & > .drawer-content {
    padding: 0 ${NOTES_GAP}px ${NOTES_GAP}px;
  }

  & > .drawer-header {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 0;
    background: ${({ bgColor }) => bgColor ?? bgGray};
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    & > .drawer-header-title {
      a {
        height: 40px;
        width: 40px;

        svg {
          color: ${royalBlue};
        }
      }
    }

    button {
      position: unset;
      top: unset;
      left: unset;
      color: ${lightGray1};
      height: 40px;
      width: 40px;
    }
  }

  ${NoteWrapDivider} {
    left: -40px !important;
    right: -40px !important;
  }
`

// #3f51b5 is RA Link color
export const SidebarOpenerLink = styled.div`
  color: #0000ee;
  cursor: pointer;
  text-decoration: none;
`
